import { createContext, useContext } from 'react';
export var DataTableSortContext = createContext(undefined);
export var useDataTableSortContext = function () { return useContext(DataTableSortContext); };
//# sourceMappingURL=DataTableSortContext.js.map